import { useEffect, useState, type ReactNode } from 'react';

interface HeadlineMessage {
  node: ReactNode;
}

const messages: HeadlineMessage[] = [
  {
    node: (
      <>
        Decide con claridad.
        <br />
        Avanza con <span className="italic">CALMA</span>.
      </>
    ),
  },
  {
    node: (
      <>
        Las mejores decisiones nacen cuando existe claridad mental y congruencia personal.
      </>
    ),
  },
];

export default function HeroSection() {
  const [active, setActive] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 120);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % messages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="inicio" className="relative min-h-[92vh] w-full overflow-hidden bg-background-50 flex items-center">
      {/* Background video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
      >
        <source
          src="https://storage.helloreaddy.io/project_files/051d548c-4efa-4d12-87d7-897fd5389524/ce104c4b-8b93-4ee1-965b-a14fd1b54d85_grok-video-892ed72c-ed21-47e9-8669-871135cd1d76.mp4"
          type="video/mp4"
        />
      </video>

      {/* White gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/95 via-background-50/75 to-background-50/40"></div>

      {/* Large translucent section number */}
      <div
        aria-hidden="true"
        className="absolute -right-6 md:right-4 top-1/2 -translate-y-1/2 font-heading text-[34vw] md:text-[20vw] leading-none text-foreground-950/5 select-none pointer-events-none"
      >
        01
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16 pt-12 md:pt-16 pb-20 md:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
          <div className="lg:col-span-12 relative text-center">
            <p className="text-black text-[11px] md:text-xs tracking-[0.3em] uppercase mb-6">
              Erika López Castañeda · Mentoría estratégica
            </p>

            {/* Rotating headline */}
            <div className="relative min-h-[200px] md:min-h-[260px] lg:min-h-[300px]">
              {messages.map((m, i) => (
                <h1
                  key={i}
                  className={`absolute inset-0 font-heading text-[42px] leading-[1.03] md:text-[64px] lg:text-[72px] xl:text-[80px] font-bold text-foreground-950 transition-opacity duration-1000 ease-out ${
                    i === active ? 'opacity-100' : 'opacity-0 pointer-events-none'
                  }`}
                >
                  {m.node}
                </h1>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-7 left-1/2 -translate-x-1/2 z-10 hidden lg:flex flex-col items-center gap-2 text-foreground-500">
        <span className="text-[10px] tracking-[0.32em] uppercase">Explora</span>
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-lg animate-scroll-pulse"></i>
        </span>
      </div>
    </section>
  );
}